import { PublicClientApplication } from "@azure/msal-browser";

const clientId = process.env.REACT_APP_ENTRA_CLIENT_ID || "";
const tenantId = process.env.REACT_APP_ENTRA_TENANT_ID || "";
const apiScope = process.env.REACT_APP_ENTRA_API_SCOPE || "";

export const msalEnabled = Boolean(clientId && tenantId);

let pcaPromise = null;

async function getPca() {
  if (!pcaPromise) {
    const pca = new PublicClientApplication({
      auth: {
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri: `${window.location.origin}/login`,
      },
      cache: { cacheLocation: "sessionStorage" },
    });
    pcaPromise = pca.initialize().then(() => pca);
  }
  return pcaPromise;
}

export async function loginWithMicrosoftPopup() {
  const pca = await getPca();
  const result = await pca.loginPopup({ scopes: apiScope ? [apiScope] : ["User.Read"] });
  return result.accessToken;
}
